import { render, staticRenderFns } from "./Pesquisa.vue?vue&type=template&id=01f7c72c&"
import script from "./Pesquisa.vue?vue&type=script&lang=js&"
export * from "./Pesquisa.vue?vue&type=script&lang=js&"
import style0 from "./Pesquisa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VDialog,VTextField})
